import { render, staticRenderFns } from "./SuperadminTransferService.vue?vue&type=template&id=1095b918&scoped=true&"
import script from "./SuperadminTransferService.vue?vue&type=script&lang=js&"
export * from "./SuperadminTransferService.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminTransferService.vue?vue&type=style&index=0&id=1095b918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095b918",
  null
  
)

export default component.exports